module.exports = __webpack_public_path__ + "static/img/huanyinen.aad35146.png";